// import Header from "../styledComponents/styledComponents";
import logo from "../../images/logo.png";
import { Header } from "../styledComponents/styledComponents";

function HeaderComp({ setState }) {
  return (
    <Header>
      <img src={logo} alt="" />
      <div>
        <input
          onChange={(event) => {
            setState(event.target.value.toLowerCase());
          }}
          type="text"
          placeholder="  Digitar Pesquisa"
        />
        <button>Pesquisar</button>
      </div>
    </Header>
  );
}

export default HeaderComp;
